import { render, staticRenderFns } from "./Clubs.vue?vue&type=template&id=020bc230&scoped=true&"
import script from "./Clubs.vue?vue&type=script&lang=js&"
export * from "./Clubs.vue?vue&type=script&lang=js&"
import style0 from "./Clubs.vue?vue&type=style&index=0&id=020bc230&scoped=true&lang=css&"
import style1 from "./Clubs.vue?vue&type=style&index=1&id=020bc230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020bc230",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
